module.exports = __webpack_public_path__ + "img/carousel-icon.f19bebe7.png";